/*
 * @Description: 统计
 * @Version: 1.0
 * @Autor: huliekao
 * @Date: 2021-05-25 18:01:45
 * @LastEditors: crm
 * @LastEditTime: 2025-03-21 14:03:45
 */
import Layout from "@/layout";
const count = [
  {
    path: "/count",
    name: "count",
    title: "统计分析",
    // redirect: "/count/schoolFollow",
    component: Layout,
    children: [
      {
        path: "schoolFollow",
        name: "schoolFollow",
        title: "校区客户跟进仪表盘",
        meta: { requireAuth: true },
        component: () => import("@/views/count/school-follow"), 
      },
      {
        path: "recruitTeacherReport",
        name: "recruitTeacherReport",
        title: "招生业绩",
        meta: { requireAuth: true },
        component: () => import("@/views/count/recruitTeacherReport"), 
      },
      {
        path:'funnelModel',
        name:'funnelModel',
        title: "销售漏斗",
        meta: { requireAuth: true },
        component: () => import("@/views/count/funnelModel"), 
      },
      {
        path:'studentEmploymentStatistics',
        name:'studentEmploymentStatistics',
        title: "学员就业统计",
        meta: { requireAuth: true },
        component: () => import("@/views/count/studentEmploymentStatistics"), 
      },
      {
        path:'oneOnOneEmploymentGuidance',
        name:'oneOnOneEmploymentGuidance',
        title: "就业一对一辅导统计",
        meta: { requireAuth: true },
        component: () => import("@/views/count/oneOnOneEmploymentGuidance"), 
      },
    ],
  },
];

export default count;
